/* The Dragonfly Library shelf data. One array entry per title across all 19 sub-series of
   the planned series (~/.claude/agents/booklet-agent-kb/06-series-roadmap.md). Adding a booklet
   to the shelf, built or planned, is one entry here, never a template or schema change.
   state: 'free' (Water Breaks the Rules only) | 'available' (built, EUR 9,95 DRAFT product) |
   'coming' (planned, not built yet: no cover, no buy action).
   Regenerated 2026-09-28 by scripts/gen-library-data.mjs from the
   booklet disk (count and titles) and the series roadmap (hook, sub-series). Available/free
   entries are carried over verbatim, never regenerated: they are the 15 live products.
   142 entries are 'coming'. Regenerate rather than hand-edit. */
window.DFL_DATA = [
  {
    "id": "NUM-01",
    "key": "108",
    "title": "The Number That Was Already There",
    "subSeries": "Number",
    "hook": "The sun and the moon each sit about 108 of their own diameters away, which is the only reason an eclipse fits.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-108-cover.png?v=1789626652",
    "link": "/products/the-number-that-was-already-there-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "NUM-02",
    "key": "369",
    "title": "Three, Six, Nine and Twelve",
    "subSeries": "Number",
    "hook": "The famous Tesla quote about 3, 6 and 9 has no source. What he actually wrote in 1919 is stranger.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-369-cover.png?v=1789626653",
    "link": "/products/three-six-nine-and-twelve-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "NUM-03",
    "key": "twelve",
    "title": "The Number in Your Hand",
    "subSeries": "Number",
    "hook": "Your thumb counts twelve on one hand, on the finger bones, which is where the dozen came from.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-twelve-cover.png?v=1789626654",
    "link": "/products/the-number-in-your-hand-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "NUM-04",
    "key": "thirteen",
    "title": "The Number We Left Out",
    "subSeries": "Number",
    "hook": "Twelve moons miss the year by eleven days. Thirteen was the correction, not the intruder.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-thirteen-cover.png?v=1789626654",
    "link": "/products/the-number-we-left-out-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "NUM-05",
    "key": "calendar",
    "title": "September Means Seven",
    "subSeries": "Number",
    "hook": "Ten days of October 1582 never happened. People went to bed on the 4th and woke on the 15th.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-calendar-cover.png?v=1789626655",
    "link": "/products/september-means-seven-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "NUM-06",
    "key": "num-06",
    "title": "Fibonacci",
    "subSeries": "Number",
    "hook": "A male bee has one parent. Count his ancestors backwards and the generations run 1, 1, 2, 3, 5, 8.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-07",
    "key": "num-07",
    "title": "Phi",
    "subSeries": "Number",
    "hook": "The nautilus shell is a logarithmic spiral, and measurement says it is not the golden one.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-08",
    "key": "num-08",
    "title": "Pi",
    "subSeries": "Number",
    "hook": "In 1897 the Indiana House of Representatives voted unanimously to legislate the value of pi.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-09",
    "key": "num-09",
    "title": "The Number Florence Did Not Ban",
    "subSeries": "Number",
    "hook": "The 1299 Florentine rule everybody cites is one guild's ledger bylaw, and it never mentions zero.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-10",
    "key": "num-10",
    "title": "The Metre Is a Piece of France",
    "subSeries": "Number",
    "hook": "The metre was defined as one ten-millionth of the distance from the pole to the equator, and the survey that fixed it was wrong.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-11",
    "key": "num-11",
    "title": "The Week Has Nothing Behind It",
    "subSeries": "Number",
    "hook": "The day, the month and the year are all in the sky. The week is the one unit with nothing above it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-12",
    "key": "num-12",
    "title": "Why Sixty",
    "subSeries": "Number",
    "hook": "Everything else went decimal. Clocks and compasses kept a base chosen in Mesopotamia, and nobody knows why sixty.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-13",
    "key": "num-13",
    "title": "Some Infinities Are Bigger",
    "subSeries": "Number",
    "hook": "Cantor proved infinity comes in sizes, and the argument fits on a postcard.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-14",
    "key": "num-14",
    "title": "The Numbers That Cannot Be Written",
    "subSeries": "Number",
    "hook": "The diagonal of a one metre square is not a fraction, and it can be proved in four lines.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-15",
    "key": "num-15",
    "title": "The Average Person Does Not Exist",
    "subSeries": "Number",
    "hook": "The US Air Force measured 4.063 pilots on ten dimensions and found nobody average.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-16",
    "key": "num-16",
    "title": "The Numbers Nobody Can Predict",
    "subSeries": "Number",
    "hook": "No formula gives the next prime, and their density follows an exact law.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-17",
    "key": "num-17",
    "title": "The Cost of a Rounding Error",
    "subSeries": "Number",
    "hook": "One tenth cannot be written in binary, and a Patriot battery drifted 687 metres.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-18",
    "key": "num-18",
    "title": "Nothing Is Ever Random",
    "subSeries": "Number",
    "hook": "Your shuffle is arithmetic from a seed, and IBM shipped one that fell on fifteen planes.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-19",
    "key": "num-19",
    "title": "Nobody Can Feel a Doubling",
    "subSeries": "Number",
    "hook": "Square 64 of the chessboard holds nine quintillion grains.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "NUM-20",
    "key": "num-20",
    "title": "The Last Physical Object",
    "subSeries": "Number",
    "hook": "Until 2019 the kilogram was a cylinder in a vault, and nobody could tell whether it had changed.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-01",
    "key": "chester",
    "title": "The Form Nobody Had Found",
    "subSeries": "Form",
    "hook": "In January 2000 a sculptor found a seven-sided solid with seven faces of equal area that no mathematician had described.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-chester-cover.png?v=1789626651",
    "link": "/products/the-form-nobody-had-found-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "FRM-02",
    "key": "frm-02",
    "title": "The Pattern You Cannot Avoid",
    "subSeries": "Form",
    "hook": "Put a compass point anywhere on a circle you just drew and draw again. Six circles close around the first, with no measuring.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-03",
    "key": "frm-03",
    "title": "There Is No Sixth",
    "subSeries": "Form",
    "hook": "Exactly five solids have identical faces and identical corners, and Euclid's Elements ends by proving there cannot be another.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-04",
    "key": "frm-04",
    "title": "A Better Cell Than the Bee Builds",
    "subSeries": "Form",
    "hook": "Fejes Toth proved in 1964 that the bee's cell base is beaten by a shape he wrote down, and another bee builds it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-05",
    "key": "frm-05",
    "title": "The Shape That Grows Without Changing",
    "subSeries": "Form",
    "hook": "A shell, a horn and a galaxy arm get bigger and keep the same shape. Only one curve does that.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-06",
    "key": "frm-06",
    "title": "The Soap Film Solves It First",
    "subSeries": "Form",
    "hook": "Dip a wire cube in soap and the film finds the minimal surface instantly, for a problem that took mathematicians a century.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-07",
    "key": "frm-07",
    "title": "The Tile That Never Repeats",
    "subSeries": "Form",
    "hook": "In 2023 a retired printing technician found a single tile that covers a floor forever without the pattern ever repeating.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-08",
    "key": "frm-08",
    "title": "The Same Tree Everywhere",
    "subSeries": "Form",
    "hook": "A river, a lung, a lightning strike and a tree are the same picture, for four unrelated reasons.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-09",
    "key": "frm-09",
    "title": "Everything Alive Is Slightly Crooked",
    "subSeries": "Form",
    "hook": "Life uses left-handed amino acids and nobody knows why; the whole left-right difference starts with spinning hairs.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-10",
    "key": "frm-10",
    "title": "The Best Way to Stack Oranges",
    "subSeries": "Form",
    "hook": "Kepler said the greengrocer was right in 1611 and it took until 2014 to prove beyond doubt.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-11",
    "key": "frm-11",
    "title": "The Shape Water Makes",
    "subSeries": "Form",
    "hook": "A raindrop has never been the shape on the forecast, and capillarity does not reach a treetop.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-12",
    "key": "frm-12",
    "title": "Everything Cracks at Ninety Degrees",
    "subSeries": "Form",
    "hook": "A crack is an open face, an open face cannot pull, and every later crack arrives square.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-13",
    "key": "frm-13",
    "title": "Why Leaves Do Not Sit Above Each Other",
    "subSeries": "Form",
    "hook": "Two physicists grew a sunflower head in a dish of magnetic oil with no plant in it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "FRM-14",
    "key": "frm-14",
    "title": "The Last Unsolved Problem",
    "subSeries": "Form",
    "hook": "The equations were written in the 1840s and whether they always behave is still a Millennium Prize problem.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-01",
    "key": "water",
    "title": "Water Breaks the Rules",
    "subSeries": "Water",
    "hook": "Is water intelligent? Could it be alive?",
    "state": "free",
    "price": null,
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/water-breaks-the-rules-cover.png?v=1790782661&width=600",
    "link": "/pages/water-breaks-the-rules",
    "linkLabel": "Get the free download"
  },
  {
    "id": "WAT-02",
    "key": "hydration",
    "title": "Thirst Knows First",
    "subSeries": "Water",
    "hook": "Drinking more is not the same as being hydrated.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-hydration-cover.png?v=1789626649",
    "link": "/products/thirst-knows-first-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "WAT-03",
    "key": "minerals",
    "title": "What the Water Carries",
    "subSeries": "Water",
    "hook": "No drop of water is really empty. It is rock, dissolved and carried.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-minerals-cover.png?v=1789626648",
    "link": "/products/what-the-water-carries-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "WAT-04",
    "key": "mineralisation",
    "title": "What the Filter Leaves Out",
    "subSeries": "Water",
    "hook": "Every filter makes a choice. What goes back in is a choice too.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-mineralisation-cover.png?v=1789626648",
    "link": "/products/what-the-filter-leaves-out-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "WAT-05",
    "key": "scg",
    "title": "Silver, Copper and Gold",
    "subSeries": "Water",
    "hook": "One column of the periodic table, ten thousand years of the same three choices.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-scg-cover.png?v=1789709952",
    "link": "/products/silver-copper-and-gold-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "WAT-06",
    "key": "wat-06",
    "title": "The Bend Is Doing Work",
    "subSeries": "Water",
    "hook": "A river never runs straight even on a flat plain, and the bend is not an accident of the ground.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-07",
    "key": "wat-07",
    "title": "Six Sides, Every Time",
    "subSeries": "Water",
    "hook": "Every snow crystal has six arms, and the reason is the angle between two hydrogen atoms.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-08",
    "key": "wat-08",
    "title": "What Is Actually In Your Tap Water",
    "subSeries": "Water",
    "hook": "Dutch tap water is among the best in the world, and it reaches the tap with no chlorine in it at all.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-09",
    "key": "wat-09",
    "title": "The Sea Inside You",
    "subSeries": "Water",
    "hook": "Blood plasma carries the same ions as seawater in nearly the same proportion, and in 1897 a Frenchman put diluted seawater into patients.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-10",
    "key": "wat-10",
    "title": "Older Than the Sun",
    "subSeries": "Water",
    "hook": "The hydrogen ratio in some of the water in your glass says it formed before the solar system did.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-11",
    "key": "wat-11",
    "title": "One Hundred Metres, No Pump",
    "subSeries": "Water",
    "hook": "A tree lifts water higher than any suction pump can, by pulling on a column held together by nothing but the water's grip on itself.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-12",
    "key": "wat-12",
    "title": "Rain Needs a Speck of Life",
    "subSeries": "Water",
    "hook": "Many raindrops start on a bacterium. Life is part of how the sky decides to let go.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WAT-13",
    "key": "wat-13",
    "title": "Ice Floats, and That Is Why You Are Here",
    "subSeries": "Water",
    "hook": "Almost every substance sinks in its own liquid. Water swells by nine percent instead, and that is why there is anything alive under a frozen lake.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-01",
    "key": "wmd-01",
    "title": "The Fourth Phase",
    "subSeries": "Water Minds",
    "hook": "Put a gel against water and a layer forms that pushes particles out of it. You can watch it happen under a microscope.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-02",
    "key": "wmd-02",
    "title": "The Magician in the Laboratory",
    "subSeries": "Water Minds",
    "hook": "Nature published his result in 1988 and then sent a professional magician to his lab to watch him repeat it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-03",
    "key": "wmd-03",
    "title": "The Nobel Laureate Who Kept Going",
    "subSeries": "Water Minds",
    "hook": "The man who found the virus behind AIDS spent his last decade on signals from water that had been diluted past the point of containing anything.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-04",
    "key": "wmd-04",
    "title": "The Picture a Drop Makes",
    "subSeries": "Water Minds",
    "hook": "Drop water into water, photograph the flow, and the same source gives the same pattern.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-05",
    "key": "wmd-05",
    "title": "Seventy Ways to Misbehave",
    "subSeries": "Water Minds",
    "hook": "One retired professor keeps the list of water's anomalies, and both sides of the argument cite the same website.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-06",
    "key": "wmd-06",
    "title": "Information, and the Courts",
    "subSeries": "Water Minds",
    "hook": "An Austrian with no laboratory said he could put information into water, sold it across Europe, and fought it out in court.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-07",
    "key": "wmd-07",
    "title": "The PhD That Never Came",
    "subSeries": "Water Minds",
    "hook": "A Dutch chemical engineer spent five years at a research institute trying to measure vitalised water, failed, and concluded that water is unfathomable.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-08",
    "key": "wmd-08",
    "title": "Five Times the Oxygen",
    "subSeries": "Water Minds",
    "hook": "A Dutch laboratory built a funnel from a shape an Austrian forester described, and measured five times the oxygen transfer at a fortieth of the energy.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-09",
    "key": "wmd-09",
    "title": "The Prison Doctor",
    "subSeries": "Water Minds",
    "hook": "He had one medicine left in an Iranian prison, and it was water.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-10",
    "key": "wmd-10",
    "title": "The Living Crystal",
    "subSeries": "Water Minds",
    "hook": "Photographed in polarised light, a living worm blazes with colour, because the tissue is ordered like a crystal.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-11",
    "key": "wmd-11",
    "title": "A Hundred Nanometres, In Step",
    "subSeries": "Water Minds",
    "hook": "Two Italian physicists argued that water contains regions where every molecule oscillates in time with the same field.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "WMD-12",
    "key": "wmd-12",
    "title": "The Chemist Who Changed Sides",
    "subSeries": "Water Minds",
    "hook": "A French professor of chemistry spent his career on materials and his last years telling wellness audiences that water is quantum.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "EVA-01",
    "key": "eva-01",
    "title": "The Photographs That Went Around the World",
    "subSeries": "Emoto & Veda Austin",
    "hook": "He froze water, photographed the crystals, and sold millions of books. The part rarely mentioned is how the photograph was chosen.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "EVA-03",
    "key": "eva-03",
    "title": "The Rice on the Windowsill",
    "subSeries": "Emoto & Veda Austin",
    "hook": "The most-repeated experiment in the world, run by hundreds of thousands of people, and almost never run blind.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "EVA-04",
    "key": "eva-04",
    "title": "Photograph Your Own Water",
    "subSeries": "Emoto & Veda Austin",
    "hook": "The method, the cold, the microscope and the patience, so the reader can stop taking anyone's word for it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "EVA-02",
    "key": "eva-02",
    "title": "Four Minutes in the Freezer",
    "subSeries": "Emoto & Veda Austin",
    "hook": "She freezes water for a fixed time, photographs the ice at one particular stage, and says the water is answering.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SCH-01",
    "key": "sch-01",
    "title": "The Man Who Watched Trout",
    "subSeries": "Schauberger",
    "hook": "A trout holds still in a torrent that would sweep you away, and then goes up the waterfall.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SCH-02",
    "key": "sch-02",
    "title": "Pull, Do Not Push",
    "subSeries": "Schauberger",
    "hook": "Every engine we build works by pushing outward. Almost nothing in nature does.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SCH-03",
    "key": "sch-03",
    "title": "Heavier Than Water",
    "subSeries": "Schauberger",
    "hook": "He built a flume that carried logs heavier than water, by curving the channel and letting the water cool.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SCH-04",
    "key": "sch-04",
    "title": "Four Degrees",
    "subSeries": "Schauberger",
    "hook": "Water is at its heaviest at four degrees above freezing, not at zero, and he built a whole philosophy on that one anomaly.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SCH-05",
    "key": "sch-05",
    "title": "The Machine and the War",
    "subSeries": "Schauberger",
    "hook": "What is documented about the Repulsine, what is legend, and how to tell them apart.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SCH-06",
    "key": "sch-06",
    "title": "What the Family Kept",
    "subSeries": "Schauberger",
    "hook": "The son turned his father's intuitions into filed patents and a teaching curriculum, and the grandson still runs the archive.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SCH-07",
    "key": "sch-07",
    "title": "The Whole Idea",
    "subSeries": "Schauberger",
    "hook": "The worldview under the other six, and the one step, from a direction to a surplus, where it stops. Bejan's constructal law as the mainstream cousin.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "RUS-01",
    "key": "russell",
    "title": "The Painter Who Redrew the Elements",
    "subSeries": "Walter Russell",
    "hook": "What does the universe look like to somebody never taught what it should look like?",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-russell-cover.png?v=1789626652",
    "link": "/products/the-painter-who-redrew-the-elements-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "RUS-02",
    "key": "rus-02",
    "title": "The Elements in a Spiral",
    "subSeries": "Walter Russell",
    "hook": "In 1926 he drew the periodic table as octaves on a spiral, and named boxes that were still empty.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "RUS-03",
    "key": "rus-03",
    "title": "The Two-Way Universe",
    "subSeries": "Walter Russell",
    "hook": "He described everything as one light in rhythmic balanced interchange between two opposed conditions.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "RUS-04",
    "key": "rus-04",
    "title": "Russell and Tesla",
    "subSeries": "Walter Russell",
    "hook": "The story that Tesla told him to seal his knowledge for a thousand years is everywhere, and sourced almost nowhere.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "REI-01",
    "key": "rei-01",
    "title": "The Exception Freud Made",
    "subSeries": "Reich",
    "hook": "He began inside psychoanalysis, at the centre of it, and ended in a United States federal prison.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "REI-02",
    "key": "rei-02",
    "title": "The Books Were Burned",
    "subSeries": "Reich",
    "hook": "In 1956 and 1957, by order of a United States court, tons of a scientist's books and journals were incinerated.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "REI-03",
    "key": "rei-03",
    "title": "The Box and the Thermometer",
    "subSeries": "Reich",
    "hook": "He said his box ran warmer than the room. Einstein tested it himself and wrote back.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "REI-04",
    "key": "rei-04",
    "title": "The Rain in Maine",
    "subSeries": "Reich",
    "hook": "In July 1953 two blueberry farmers paid him to make it rain, and the newspaper printed what happened next.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "REI-05",
    "key": "rei-05",
    "title": "Armour in the Muscle",
    "subSeries": "Reich",
    "hook": "He argued that a person's history sets in their muscles, and body work has been arguing about it ever since.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEL-01",
    "key": "tel-01",
    "title": "The Circles Nobody Counted",
    "subSeries": "Tellinger",
    "hook": "Tens of thousands of stone circles cover the hills of Mpumalanga, and there is no agreement about who built them or when.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEL-02",
    "key": "tel-02",
    "title": "The Day the Sea Boiled",
    "subSeries": "Tellinger",
    "hook": "A ring of standing stones on an escarpment, an equinox alignment, and a date claim archaeologists reject.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEL-03",
    "key": "tel-03",
    "title": "The Stone That Rings",
    "subSeries": "Tellinger",
    "hook": "Some of those stones ring like metal when struck, and somebody put a microphone on them.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEL-04",
    "key": "tel-04",
    "title": "Towns That Tried to Live Without Money",
    "subSeries": "Tellinger",
    "hook": "Contributionism, in his own words, and what the record shows about the towns that tried it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEN-01",
    "key": "ten-01",
    "title": "The Surgeon Who Lost His Sight",
    "subSeries": "Tennant",
    "hook": "An eye surgeon who had done tens of thousands of operations could not see well enough to operate, and started reading voltmeters.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEN-02",
    "key": "ten-02",
    "title": "Minus Twenty Millivolts",
    "subSeries": "Tennant",
    "hook": "He puts a number on the difference between a cell that maintains itself and one that does not.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEN-03",
    "key": "ten-03",
    "title": "Squeeze It and It Sparks",
    "subSeries": "Tennant",
    "hook": "His account of where the body stores the charge, and why he thinks a stiff muscle is a flat one.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "TEN-04",
    "key": "ten-04",
    "title": "The Voltage Nobody Argues About",
    "subSeries": "Tennant",
    "hook": "Cut your skin and a current starts flowing within seconds. It has been measured since the 1840s.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ETH-01",
    "key": "eth-01",
    "title": "The Most Famous Nothing",
    "subSeries": "Ether",
    "hook": "In 1887 two Americans built the most sensitive experiment on Earth to measure the ether, and measured nothing at all.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ETH-02",
    "key": "eth-02",
    "title": "The Man Who Kept Measuring",
    "subSeries": "Ether",
    "hook": "Dayton Miller repeated that experiment for decades, took over 200,000 readings, and kept getting a small number instead of zero.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ETH-03",
    "key": "eth-03",
    "title": "Empty Space Pushes",
    "subSeries": "Ether",
    "hook": "Put two plates close together in a perfect vacuum and they are pushed together by the vacuum itself. Measured, 1997.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ETH-04",
    "key": "eth-04",
    "title": "Zero Point",
    "subSeries": "Ether",
    "hook": "The energy the physics actually describes, and the energy the advertising describes, side by side.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ETH-05",
    "key": "eth-05",
    "title": "Five Names, One Description",
    "subSeries": "Ether",
    "hook": "Orgone, prana, chi, od, vril. Five cultures describing the same thing, and no instrument any two of them would agree on.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-01",
    "key": "sound",
    "title": "The Sound of Nature",
    "subSeries": "Sound",
    "hook": "Why does a waterfall never tire the ear?",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-sound-cover.png?v=1789626647",
    "link": "/products/the-sound-of-nature-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "SND-02",
    "key": "snd-02",
    "title": "Sound You Can See",
    "subSeries": "Sound",
    "hook": "Sand on a steel plate falls into a mandala at one pitch, and a different one a tone higher.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-03",
    "key": "snd-03",
    "title": "The Cone That Radiates a Sphere",
    "subSeries": "Sound",
    "hook": "Every speaker you have owned beams sound forward. He built one that lets go of it in all directions.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-04",
    "key": "snd-04",
    "title": "Four Hundred and Forty",
    "subSeries": "Sound",
    "hook": "The pitch the whole world tunes to was fixed at a conference in 1939, and the argument about it has never stopped.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-05",
    "key": "snd-05",
    "title": "Your Ear Makes Sound",
    "subSeries": "Sound",
    "hook": "A healthy ear emits sound of its own. Newborn hearing tests work by listening for it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-06",
    "key": "snd-06",
    "title": "The Note You Cannot Hear",
    "subSeries": "Sound",
    "hook": "A laboratory traced its own ghost to a fan vibrating the room at 18.9 hertz.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-07",
    "key": "snd-07",
    "title": "There Is No Such Thing as Silence",
    "subSeries": "Sound",
    "hook": "In a proper anechoic chamber the loudest thing is your own blood.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-08",
    "key": "snd-08",
    "title": "Two Songs at Once",
    "subSeries": "Sound",
    "hook": "A bird has two voice boxes and can sing a duet with itself.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-09",
    "key": "snd-09",
    "title": "The Notes Between the Notes",
    "subSeries": "Sound",
    "hook": "A piano is deliberately out of tune, because twelve perfect fifths overshoot seven octaves.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "SND-10",
    "key": "snd-10",
    "title": "Two Songs at Once",
    "subSeries": "Sound",
    "hook": "A songbird's voice box sits where the windpipe forks, so it has two, each with its own nerve.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-01",
    "key": "lgt-01",
    "title": "Your Skin Does Chemistry",
    "subSeries": "Light",
    "hook": "Skin is not a wrapper. Sunlight drives reactions in it that happen nowhere else in the body.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-02",
    "key": "lgt-02",
    "title": "The Molecule That Absorbs Red",
    "subSeries": "Light",
    "hook": "Deep inside the cell sits an enzyme that absorbs red and near-infrared light, which is the whole basis of the field.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-03",
    "key": "lgt-03",
    "title": "The Cells That See Without Seeing",
    "subSeries": "Light",
    "hook": "In 2002 a third kind of light-sensing cell was found in the human eye, and it does not make pictures. It sets the clock.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-04",
    "key": "lgt-04",
    "title": "Living Things Glow",
    "subSeries": "Light",
    "hook": "Tissue emits a handful of photons per second per square centimetre. It takes a photomultiplier in a dark room to see it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-05",
    "key": "lgt-05",
    "title": "Colour Happens in Your Head",
    "subSeries": "Light",
    "hook": "Magenta has no wavelength. Your brain makes it to close a gap.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-06",
    "key": "lgt-06",
    "title": "The Blue That Is Not the Sky",
    "subSeries": "Light",
    "hook": "Deep water, glacier ice and the Martian sky are blue for three different reasons, none of them reflection.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-07",
    "key": "lgt-07",
    "title": "Light Pushes",
    "subSeries": "Light",
    "hook": "Sunlight has pressure. Spacecraft have already sailed on it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-08",
    "key": "lgt-08",
    "title": "The Colours That Are Not There",
    "subSeries": "Light",
    "hook": "A Morpho wing has no blue pigment; crush it and the colour goes while the material is unchanged.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-09",
    "key": "lgt-09",
    "title": "The Sky Is the Wrong Colour",
    "subSeries": "Light",
    "hook": "By the inverse-fourth-power law the sky should be violet, and it never is anywhere.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "LGT-10",
    "key": "lgt-10",
    "title": "Twelve Things About Red Light",
    "subSeries": "Light",
    "hook": "Half the light the sun sends is in a band our houses were designed to leave out, and the clock in the eye is tuned to the other end.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-01",
    "key": "heart",
    "title": "Is the Heart a Pump?",
    "subSeries": "Body",
    "hook": "It wrings, like a hand wringing out a towel, and lets go.",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-heart-cover.png?v=1789626650",
    "link": "/products/is-the-heart-a-pump-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "BOD-02",
    "key": "bod-02",
    "title": "The Body Is Not a Machine",
    "subSeries": "Body",
    "hook": "Pull on the skin of your forearm and something moves at your shoulder. There is no joint between them.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-03",
    "key": "bod-03",
    "title": "The Organ They Threw Away",
    "subSeries": "Body",
    "hook": "For four hundred years anatomists cut the white tissue away to get to the muscle, and drew the body without it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-04",
    "key": "bod-04",
    "title": "Nothing Stacks",
    "subSeries": "Body",
    "hook": "Press one strut of a tensegrity model and the whole thing answers. Your skeleton does not sit on itself like bricks.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-05",
    "key": "bod-05",
    "title": "The Second Brain",
    "subSeries": "Body",
    "hook": "The gut carries hundreds of millions of neurons and will keep running its own program with the nerve to the brain cut.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-06",
    "key": "bod-06",
    "title": "It Is Not the Oxygen",
    "subSeries": "Body",
    "hook": "The urge to breathe is triggered by carbon dioxide rising, not by oxygen running out.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-07",
    "key": "bod-07",
    "title": "The Skeleton Is Never Finished",
    "subSeries": "Body",
    "hook": "Bone is torn down and rebuilt continuously, and it rebuilds along the lines of the load you put on it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-08",
    "key": "bod-08",
    "title": "Count the Molecules, Not the Kilos",
    "subSeries": "Body",
    "hook": "By weight you are about 60 percent water. By molecule count you are about 99 percent water.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "BOD-09",
    "key": "balloon",
    "title": "The Body Is a Balloon",
    "subSeries": "Body",
    "hook": "Is a body built like a wall, or like a balloon?",
    "state": "available",
    "price": "€ 9,95",
    "cover": "https://cdn.shopify.com/s/files/1/0885/3798/9458/files/dragonfly-library-balloon-cover.png?v=1789707811",
    "link": "/products/the-body-is-a-balloon-booklet",
    "linkLabel": "Get the booklet"
  },
  {
    "id": "BOD-10",
    "key": "bod-10",
    "title": "Twelve Ways to Tell Your Body It Is Safe",
    "subSeries": "Body",
    "hook": "Roughly four fibres in five in the vagus nerve carry the report up to the brain, not orders down from it, and a body sets its heart rate, breathing and digestion off signals read below the level where you decide anything.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ENR-01",
    "key": "enr-01",
    "title": "The Current in a Cut",
    "subSeries": "Energy",
    "hook": "Break the skin and a steady electric current starts flowing out of the wound within a second. It was first measured in the 1840s.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ENR-02",
    "key": "enr-02",
    "title": "The Planet Hums",
    "subSeries": "Energy",
    "hook": "The space between the ground and the ionosphere rings at about 7.83 hertz, and it has been recorded continuously since 1960.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ENR-03",
    "key": "enr-03",
    "title": "What EMF Actually Is",
    "subSeries": "Energy",
    "hook": "One spectrum, one dividing line, and the line is not where most arguments put it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ENR-04",
    "key": "enr-04",
    "title": "Your Power Stations Were Bacteria",
    "subSeries": "Energy",
    "hook": "The parts of your cells that make energy carry their own DNA, because they used to be separate organisms.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ENR-05",
    "key": "enr-05",
    "title": "The Patents That Went Nowhere",
    "subSeries": "Energy",
    "hook": "A granted patent is a record that somebody described something, and nothing more. Here is what that actually means.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ENR-06",
    "key": "enr-06",
    "title": "Fifty Hertz",
    "subSeries": "Energy",
    "hook": "Everything electrical you own is tuned to a number a committee chose, and the other half of the world chose a different one.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "INV-01",
    "key": "inv-01",
    "title": "They Could Not Make Them Sick",
    "subSeries": "Invisible Rainbow",
    "hook": "In November 1918, at the height of the worst pandemic in modern history, American doctors tried to give sixty-two healthy sailors influenza on purpose, and could not do it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "INV-02",
    "key": "inv-02",
    "title": "The Heart Attack Arrives",
    "subSeries": "Invisible Rainbow",
    "hook": "The disease behind it is four thousand years old, found calcified in mummies. The name for it, and the diagnosis, is about a hundred.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "INV-03",
    "key": "inv-03",
    "title": "The Bees and the Birds",
    "subSeries": "Invisible Rainbow",
    "hook": "A robin's compass runs on blue light. Turn the light yellow and it stops working.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "INV-04",
    "key": "inv-04",
    "title": "The Moscow Signal",
    "subSeries": "Invisible Rainbow",
    "hook": "For twenty-three years a beam of microwaves was aimed at the American embassy in Moscow. The Americans found it almost immediately, and did not tell the people working inside the building for another twenty-three years.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HOM-01",
    "key": "hom-01",
    "title": "The Room You Sleep In",
    "subSeries": "Home",
    "hook": "You spend a third of your life in one room and probably chose it for the view.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HOM-02",
    "key": "hom-02",
    "title": "The Air You Breathe Twice",
    "subSeries": "Home",
    "hook": "A closed bedroom passes 1,000 parts per million of carbon dioxide within hours, and decision-test scores fall measurably above that.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HOM-03",
    "key": "hom-03",
    "title": "Every Room Has a Note",
    "subSeries": "Home",
    "hook": "Clap once in your hallway. The tail you hear is the room telling you its size.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HOM-04",
    "key": "hom-04",
    "title": "The Last Ten Metres",
    "subSeries": "Home",
    "hook": "Water can leave the treatment plant clean and pick up its character in your own pipes.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HOM-05",
    "key": "hom-05",
    "title": "Light After Dark",
    "subSeries": "Home",
    "hook": "A phone at arm's length at midnight delivers more light to the eye than a full moon on snow.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-01",
    "key": "ert-01",
    "title": "Twelve Things About Trees",
    "subSeries": "Earth",
    "hook": "The largest organism in a forest may be the forest.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-02",
    "key": "ert-02",
    "title": "Twelve Things About Bees",
    "subSeries": "Earth",
    "hook": "A returning bee dances the direction and the distance of a flower, and other bees fly there on the instructions.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-03",
    "key": "ert-03",
    "title": "A Teaspoon of Soil",
    "subSeries": "Earth",
    "hook": "One teaspoon of living soil holds more organisms than there are people on Earth.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-04",
    "key": "ert-04",
    "title": "The Network Under the Forest",
    "subSeries": "Earth",
    "hook": "Carbon put into one tree turns up in a neighbouring tree of a different species, traced with isotopes.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-05",
    "key": "ert-05",
    "title": "North Has Moved Before",
    "subSeries": "Earth",
    "hook": "The magnetic poles have swapped, repeatedly, and the record of it is frozen into the seabed.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-06",
    "key": "ert-06",
    "title": "A River Will Not Go Straight",
    "subSeries": "Earth",
    "hook": "Straighten a river and it will bend again, or flood. The bend is the river doing its job.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-07",
    "key": "ert-07",
    "title": "The Ocean Turns Over",
    "subSeries": "Earth",
    "hook": "A drop of water sinking off Greenland may not see the surface again for a thousand years.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-08",
    "key": "ert-08",
    "title": "How Old Is a Spring",
    "subSeries": "Earth",
    "hook": "Water from a mountain spring can be dated, and it is often older than the country it comes out in.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-09",
    "key": "ert-09",
    "title": "The Ground Carries a Charge",
    "subSeries": "Earth",
    "hook": "Stand on wet grass and your body settles to the same electrical potential as the planet under it, which is measurable with a voltmeter (the \"about two seconds\" figure once noted here has no traceable physical basis; the real time constant is microseconds). Includes the animal page: a dog or a cat that has been outside is already at the ground's potential, so stroking one connects you to it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-11",
    "key": "ert-11",
    "title": "Go and Look",
    "subSeries": "Earth",
    "hook": "Twelve measurements of the shape and motion of the Earth, each with a name, a date and equipment attached, run by people who went and got an answer rather than assumed one.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "ERT-10",
    "key": "ert-10",
    "title": "The Cable Man",
    "subSeries": "Earth",
    "hook": "Clint Ober spent his working life grounding cable television systems, then asked in his fifties whether the same thing applied to a person. A portrait, in the Russell and Schauberger manner.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-01",
    "key": "his-01",
    "title": "They Buried It On Purpose",
    "subSeries": "History & Pyramids",
    "hook": "Eleven thousand years ago people carved multi-tonne pillars with flint, stood them in rings, used the place for centuries, and the rooms ended up full of rubble. Who put it there is still open.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-02",
    "key": "his-02",
    "title": "The Great Pyramid Has Eight Sides",
    "subSeries": "History & Pyramids",
    "hook": "Each face is very slightly hollowed, which is invisible from the ground and shows from the air at the right hour.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-03",
    "key": "his-03",
    "title": "The Water Marks on the Sphinx",
    "subSeries": "History & Pyramids",
    "hook": "A geologist looked at the enclosure walls and said that weathering was made by rain, in a place with no rain.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-04",
    "key": "his-04",
    "title": "Lost Technology",
    "subSeries": "History & Pyramids",
    "hook": "A geared astronomical computer from the sea floor, concrete that repairs itself, and steel nobody can reproduce.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-05",
    "key": "his-05",
    "title": "Sudan Has More Pyramids Than Egypt",
    "subSeries": "History & Pyramids",
    "hook": "Roughly twice as many, and almost nobody visits them.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-06",
    "key": "his-06",
    "title": "The Stone Still in the Quarry",
    "subSeries": "History & Pyramids",
    "hook": "At Baalbek a cut block of about a thousand tonnes is still lying where it was carved, because nobody moved it.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-07",
    "key": "his-07",
    "title": "The Decade the Climate Fell Over",
    "subSeries": "History & Pyramids",
    "hook": "Ice cores show the northern climate dropping and then recovering within about a human lifetime, twice.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-08",
    "key": "his-08",
    "title": "Five Months in the Dark",
    "subSeries": "History & Pyramids",
    "hook": "Richard Byrd is remembered for flying over both poles. The thing nobody else has done is what he actually spent five months on: sitting alone in a hole in the ice to take a reading, while the stove keeping him warm was poisoning him.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  },
  {
    "id": "HIS-09",
    "key": "his-09",
    "title": "The Seed or the Soil",
    "subSeries": "History & Pyramids",
    "hook": "Two nineteenth-century Frenchmen who could not stand each other are still deciding what people believe makes them sick: Pasteur put the emphasis on the germ, Bechamp on the ground it lands in.",
    "state": "coming",
    "price": null,
    "cover": null,
    "link": null,
    "linkLabel": null
  }
];
window.DFL_SUBSERIES_ORDER = [
  "Number",
  "Form",
  "Water",
  "Water Minds",
  "Emoto & Veda Austin",
  "Schauberger",
  "Walter Russell",
  "Reich",
  "Tellinger",
  "Tennant",
  "Ether",
  "Sound",
  "Light",
  "Body",
  "Energy",
  "Invisible Rainbow",
  "Home",
  "Earth",
  "History & Pyramids"
];
